export default __webpack_public_path__ + "static/media/ort01.6b0f69b8.jpg";